import { createTheme, MantineProvider, NumberInput, PinInput } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import dayjs from "dayjs";
import { useEffect } from "react";
import toast from "react-hot-toast";

import logoPB from "@/assets/images/logo-dark-1_a.svg";
import { useWindowLocationHost } from "@/hooks/useWindowLocationHost";
import { DATE_PATTERNS, MODAL_HANDLER } from "@/lib/Mantine";
import { useGetCompanyByHostQuery } from "@/store/apis/nextcargo";

export const Route = createFileRoute("/_auth")({
  component: RouteComponent,
  beforeLoad: ({ matches, context }) => {
    const store = context.store.getState();
    const { auth } = store;

    const driverToken = auth.driver?.accessToken;
    const appToken = auth.expedition?.accessToken;

    const expeditionLoginPath = matches.find((match) => match.routeId === "/_auth/expedicao/login");
    const appLoginPath = matches.find((match) => match.routeId === "/_auth/app/login");

    if (driverToken && !!appLoginPath) {
      throw redirect({ to: "/app" });
    }

    if (appToken && !!expeditionLoginPath) {
      throw redirect({ to: "/expedicao" });
    }
  }
});

const theme = createTheme({
  components: {
    DatePickerInput: DatePickerInput.extend({
      defaultProps: {
        defaultDate: dayjs().subtract(18, "year").format(DATE_PATTERNS.GLOBAL.DATE),
        maxDate: dayjs().format(DATE_PATTERNS.GLOBAL.DATE),
        minDate: dayjs().subtract(80, "year").format(DATE_PATTERNS.GLOBAL.DATE)
      }
    }),
    NumberInput: NumberInput.extend({
      defaultProps: {
        clampBehavior: "strict",
        min: 0,
        max: 100,
        allowNegative: false
      }
    }),
    PinInput: PinInput.extend({
      defaultProps: {
        inputMode: "numeric"
      }
    })
  }
});

function RouteComponent() {
  const { windowLocationHost, subDomain } = useWindowLocationHost();
  const { data: company } = useGetCompanyByHostQuery({ host: windowLocationHost }, { skip: !subDomain });

  useEffect(() => {
    if (company && !document.cookie.match("userTerm")) {
      MODAL_HANDLER.acceptTerms();
    }

    toast.dismissAll();
  }, []);

  return (
    <MantineProvider theme={theme}>
      <main className="relative flex min-h-dvh justify-center bg-[#19222a]">
        <Outlet />

        <div className="absolute bottom-6 flex flex-col items-center text-gray-500">
          <p className="font-medium">Powered by</p>
          <img className="mt-2 w-44" src={logoPB} alt="" />
        </div>
      </main>
    </MantineProvider>
  );
}
